module.exports = __webpack_public_path__ + "static/img/cvs_tip.0660954d.png";